import styles from './auth.module.scss';
import formStyles from 'legacy/common/components/form/Form.module.scss';

import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import FormWrapper from 'legacy/auth/components/FormWrapper';
import SignUpForm from 'legacy/auth/components/legacy/SignupForm';
import SocialRegister from 'legacy/auth/components/legacy/SocialRegister';
import Wrapper from 'legacy/common/components/layout/BackgroundWrapper';

const EmailRegister = () => {
  const { t } = useTranslation('auth');
  const { query } = useRouter();

  return (
    <Wrapper>
      <FormWrapper title="Welcome to Bounce">
        <SignUpForm />

        <div className={formStyles.separator}>
          <span />
          <div>{t('common.or')}</div>
          <span />
        </div>
        <div className={styles.forgotPassword}>
          {t('common.alreadyHaveAccount')}
          <Link
            href={{
              pathname: '/login',
              query: { ...query, type: 'email' }
            }}
            className={styles.link}
            data-test="button-log-in"
          >
            {' '}
            {t('buttons.logIn')}
          </Link>
        </div>
        <SocialRegister />
      </FormWrapper>
    </Wrapper>
  );
};

export default EmailRegister;
